import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import {
  INumberFormData,
  IPhoneSystemNumberEditFormProps,
} from './PhoneSystemNumberEditForm.container'
import { useUpdatePhoneSystemNumberMutation } from 'src/generated/graphql'

export type IPhoneSystemNumberEditFormComponentProps = IPhoneSystemNumberEditFormProps &
  InjectedFormProps<INumberFormData>

export const PhoneSystemNumberEditFormComponent = (
  props: IPhoneSystemNumberEditFormComponentProps
) => {
  const { submitting, handleSubmit, onAfterSubmit } = props
  const [updatePhoneSystemNumber] = useUpdatePhoneSystemNumberMutation()

  return (
    <Form
      onSubmit={handleSubmit(async variables => {
        await updatePhoneSystemNumber({ variables })
        onAfterSubmit()
      })}
    >
      <Field name="customerReference" label="Name" component={Input} />
      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
        <Button color="tertiary" loading={submitting} disabled={submitting} type="submit">
          Update
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberEditForm/PhoneSystemNumberEditForm.tsx